/** Integrations kartalari uchun umumiy boshqaruv: nusxalanadigan maydon */
import { useTranslation } from "react-i18next";
import { Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/field";
import { toast } from "@/components/ui/toast";

export function CopyField({ label, value }: { label?: string; value: string }) {
  const { t } = useTranslation("settings");
  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      toast.success(t("google.copied"));
    } catch {
      toast.error(t("google.copyFailed"));
    }
  }
  return (
    <div>
      {label && <div className="mb-1 text-[12px] font-semibold">{label}</div>}
      <div className="flex gap-2">
        <Input value={value} readOnly className="bg-fill/40 font-mono text-[12px]" onFocus={(e) => e.currentTarget.select()} />
        <Button onClick={copy} aria-label={t("google.copy")} title={t("google.copy")}>
          <Copy size={14} />
        </Button>
      </div>
    </div>
  );
}
